import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { showMessage, deleteMessage } from "../../Redux/UIMenus/uiDetailsConsoleMenuSlice"
import { E_MisureOmbrelloni, E_GenereOmbrellone, E_MainLato, E_TipoOmbrellone, E_ConfOmbrelloniContrapposti } from '../Utils/enumerations'
import { handleOmbrelloniDimensioneAuto, handleOmbrelloniDimensioni, handleDataOmbrelloni, handleOmbrelloniLato } from "../../Redux/UIMenus/uiOmbrelloniMenuSlice"
import { returnSymbolString } from "../Utils/utilFunctions"
import { ombrelloniConfiguration } from '../Utils/meshesConfiguration'

import ClonedObject from "../Utils/ClonedObject"
import Grondaie from './Grondaie/Grondaie'
import { setLunghezzaLateraleCristal } from '../../Redux/UIMenus/uiLateraleCristalMenuSlice'

// Genera gli ombrelloni
export default function Ombrelloni() { 
    const larghezzaPavimento = useSelector(state => state.uiMainMenu.larghezza);
    const lunghezzaPavimento = useSelector(state => state.uiMainMenu.lunghezza);
    const isPedanaVisible = useSelector(state => state.uiPedanaMenu.isVisible);
    const altezzaPedana = useSelector(state => state.uiPedanaMenu.realAltezza);
    const ombrelloniMenuVisible = useSelector(state => state.uiOmbrelloniMenu.isVisible);
    const selezioneMisuraAutomaticaOmbr = useSelector(state => state.uiOmbrelloniMenu.selezioneMisuraAutomatica);
    const genereOmbrelloni = useSelector(state => state.uiOmbrelloniMenu.genereOmbrellone);
    const tipoOmbrelloni = useSelector(state => state.uiOmbrelloniMenu.tipoOmbrellone);
    const misuraOmbrelloni = useSelector(state => state.uiOmbrelloniMenu.misureOmbrellone);
    const misuraAutomaticaOmbrelloni = useSelector(state => state.uiOmbrelloniMenu.misuraOmbrelloneAutomatica);
    const latoOmbrelloni = useSelector(state => state.uiOmbrelloniMenu.latoOmbrelloni);  
    const tessutoOmbrelloni = useSelector(state => state.uiOmbrelloniMenu.coloreTessutoOmbrelloni);
    const isMantovanaSelected = useSelector(state => state.uiOmbrelloniMenu.mantovana);
    const isGrondaieSelected = useSelector(state => state.uiOmbrelloniMenu.grondaie);
    const isVelcroSelected = useSelector(state => state.uiOmbrelloniMenu.velcro);
    const isOmbrelloniContrappostiSelected = useSelector(state => state.uiOmbrelloniMenu.ombrelloniContrapposti);
    const ombrelloniContrappostiConfiguration = useSelector(state => state.uiOmbrelloniMenu.confOmbrelloniContrapposti);
    const hasLed = useSelector(state => state.uiOmbrelloniMenu.hasLed);

    const [ombrelloniArray, setOmbrelloniArray] = useState([]);  
    const [indexLatoPrincipale, setIndexLatoPrincipale] = useState(0);
    const [misuraPrincipaleOmbrellone, setMisurePrincipaleOmbrellone] = useState(0);
    const [misuraSecondariaOmbrellone, setMisuraSecondariaOmbrellone] = useState(0);

    const dispatch = useDispatch();

    const latoPrincipaleStr = "principale";
    const latoSecondarioStr = "secondario";
    
    // funzione di utility che converte la misura delle stringa delle grandezze ombrelloni in numeri reali
    const convertMisuraInNumero = (misura, lato) => {
        const xCharacterIndex = misura.indexOf("X");
        const primaMisuraStr = misura.substring(xCharacterIndex+1, misura.length);
        const secondaMisuraStr = misura.substring(0, xCharacterIndex); 
            
        // Sostituisce la virgola con il punto (per fare il numero)
        const vCharacterIndex1 = primaMisuraStr.indexOf(",");  
        const vCharacterIndex2 = secondaMisuraStr.indexOf(","); 
        let primoNum = 0;
        let secondoNum = 0;
        // C'è la virgola nel numero principale
        if (vCharacterIndex1 !== -1) {
            const firstNumb = primaMisuraStr.substring(0, vCharacterIndex1);
            const secondNumb = primaMisuraStr.substring(vCharacterIndex1+1, primaMisuraStr.length);
            const totalNumb = firstNumb + "." + secondNumb;
            primoNum = totalNumb * 1;
        } else {
            primoNum = primaMisuraStr * 1;           
        }
        // C'è la virgola nel numero secondario
        if (vCharacterIndex2 !== -1) {
            const firstNumb = secondaMisuraStr.substring(0, vCharacterIndex2);
            const secondNumb = secondaMisuraStr.substring(vCharacterIndex2+1, secondaMisuraStr.length);
            const totalNumb = firstNumb + "." + secondNumb;
            secondoNum = totalNumb * 1;      
        } else {
            secondoNum = secondaMisuraStr * 1;             
        }     
        if (lato === "principale") {         
            return primoNum >= secondoNum ? primoNum : secondoNum;
        }          
        else if (lato === "secondario") {       
            return primoNum < secondoNum ? primoNum : secondoNum;
        }
    }

    // Funzione di utility per ricavare l'indice dell'ombrellone selezionato nell'elenco delle meshes
    const getIndexOmbrellone = () => {
        const indexOmbrellone = ombrelloniConfiguration.findIndex(element => element.meshSpecificName.toString() === tipoOmbrelloni.toString());
        // Se l'indice è negativo, ritorna il primo    
        if (indexOmbrellone === -1) return 0;     
        else return indexOmbrellone;       
    }

    // Funzione di utility per ricavare la misura principale dell'ombrellone selezionato
    const getMisuraPrincipale = (misOmbrellone) => {     
        const misuraPrincipale = convertMisuraInNumero(returnSymbolString(misOmbrellone.toString()), latoPrincipaleStr);
        setMisurePrincipaleOmbrellone(misuraPrincipale);
        return misuraPrincipale;
    }    

    // Funzione di utility per ricavare la misura secondaria dell'ombrellone selezionato
    const getMisuraSecondaria = (misOmbrellone) => {     
        const misuraSecondaria = convertMisuraInNumero(returnSymbolString(misOmbrellone.toString()), latoSecondarioStr);
        setMisuraSecondariaOmbrellone(misuraSecondaria);
        return misuraSecondaria;
    }  

    // Seleziona la misura principale ideale per il tipo di ombrellone nel caso sia selezionata la misura automatica
    const selectOmbrelloneIdealMeasure = (measures, mainDimension, secondaryDimension) => {
        let tempArray = [];
        let bestFitPrimary = Infinity;
        let bestFitSecondary = Infinity;
        let selectedMeasure = measures[0];
        let maxSecondaryMeasure = 0;     
        measures.forEach(mSymb => {
            // Se è selezionato il scegli, salta 
            if (mSymb.toString() === E_MisureOmbrelloni.Scegli.toString()) return;
            const misuraPrincipale = getMisuraPrincipale(mSymb);
            // Verifica quanto può starci all'interno della misura
            const fit = mainDimension % misuraPrincipale;
            // Se la nuova misura è inferiore a quella precedente (c'è un fit migliore), sostituiscila
            if (fit <= bestFitPrimary) {   
                // Resetta l'array se non è la stessa misura sul lato principale
                if (fit !== bestFitPrimary) {
                    tempArray = [];
                }                          
                bestFitPrimary = fit;    
                selectedMeasure = mSymb;   
                // Aggiorna l'array     
                tempArray.push(mSymb)              
            }            
            });   
            // Seleziona la misura secondaria massima  
            tempArray.forEach(el => {
                const misuraSecondaria = getMisuraSecondaria(el);    
                if (misuraSecondaria > maxSecondaryMeasure) {
                    maxSecondaryMeasure = misuraSecondaria;
                }   
            });      
            // Verifica la misura secondaria
            tempArray.forEach(el => { 
                const misuraSecondaria = getMisuraSecondaria(el);     
                // Se la misura secondaria è uguale alla misura massima, e il lato è maggiore della misura massima, selezionala
                if (misuraSecondaria === maxSecondaryMeasure && secondaryDimension > maxSecondaryMeasure) {                 
                    selectedMeasure = el;      
                    return;
                }
                // Verifica quanto può starci all'interno della misura
                const fit = secondaryDimension % misuraSecondaria;
                // Se la nuova misura è inferiore a quella precedente (c'è un fit migliore), sostituiscila               
                if (fit <= bestFitSecondary) {              
                    bestFitSecondary = fit;    
                    selectedMeasure = el;       
                    tempArray.push(el);              
                }       
            });         
            return {
                selectedMeasure,
                maxSecondaryMeasure,   
            };        
    }

    // Coside generale per il calcolo della posizione, rotazione, scala degli ombrelloni
    const generaOmbrelloniMainCode = (genereOmbrellone, latoOmbrelloni, lunghezzaPavimento, larghezzaPavimento, offsetPavimentoEsterno, _mesh, isContrapposto) => {      
        // Se non c'è una misura adeguata (nel caso di scelta delle misure manuale, esci)
        if (!selezioneMisuraAutomaticaOmbr && misuraOmbrelloni.toString() === E_MisureOmbrelloni.Scegli.toString()) {         
            dispatch(showMessage("Scegli una misura adeguata per gli ombrelloni"));
            return;
        }   
        dispatch(deleteMessage());
        let misura = selezioneMisuraAutomaticaOmbr ? misuraAutomaticaOmbrelloni : misuraOmbrelloni;
        let getMisuraScaleX;
        let getMisuraScaleZ;
        let yRotation;
        let yRotationContrapposto;
        let primaryDim;
        let secondaryDim;       
        let tempArray = [];
        switch(latoOmbrelloni.toString()) {
            case E_MainLato.Lato1.toString():
                getMisuraScaleX = getMisuraSecondaria(misura);
                getMisuraScaleZ = getMisuraPrincipale(misura);
                yRotation = Math.PI;
                yRotationContrapposto = 0;
                primaryDim = larghezzaPavimento;
                secondaryDim = lunghezzaPavimento;      
            break;
            case E_MainLato.Lato2.toString(): 
                getMisuraScaleX = getMisuraPrincipale(misura);
                getMisuraScaleZ = getMisuraSecondaria(misura);
                yRotation = Math.PI / 2;
                yRotationContrapposto = -Math.PI/2;
                primaryDim = lunghezzaPavimento;
                secondaryDim = larghezzaPavimento;   
            break;
            case E_MainLato.Lato3.toString(): 
                getMisuraScaleX = getMisuraSecondaria(misura);
                getMisuraScaleZ = getMisuraPrincipale(misura);
                yRotation = Math.PI * 2;
                yRotationContrapposto = -Math.PI;
                primaryDim = larghezzaPavimento;
                secondaryDim = lunghezzaPavimento;     
            break;
            case E_MainLato.Lato4.toString(): 
                getMisuraScaleX = getMisuraPrincipale(misura);
                getMisuraScaleZ = getMisuraSecondaria(misura);
                yRotation = Math.PI * 3/2;
                yRotationContrapposto = -Math.PI * 3/2;
                primaryDim = lunghezzaPavimento;
                secondaryDim = larghezzaPavimento;   
            break;                    
            default:
                getMisuraScaleX = getMisuraSecondaria(misura);
                getMisuraScaleZ = getMisuraPrincipale(misura);
                yRotation = Math.PI;
                yRotationContrapposto = 0;
                primaryDim = larghezzaPavimento;
                secondaryDim = lunghezzaPavimento;      
            break;
        }        
        // INIZIALIZZAZIONE OMBRELLONI
        // Scala degli ombrelloni      
        let scale = [ombrelloniConfiguration[getIndexOmbrellone()].meshScale[0] * getMisuraScaleX, 
                    ombrelloniConfiguration[getIndexOmbrellone()].meshScale[1], 
                    ombrelloniConfiguration[getIndexOmbrellone()].meshScale[2] * getMisuraScaleZ];                       
        // Rotazione degli ombrelloni
        let rotation = [0, yRotation, 0];
        // Seleziona la posizione degli ombrelloni
        let posX = 0;
        let posY = 0;
        let posZ = 0; 
        let contrappostoX = 0;
        let contrappostoZ = 0;
        // Seleziona le misure ideali
        const idealMeasure = selectOmbrelloneIdealMeasure(ombrelloniConfiguration[getIndexOmbrellone()].meshDimensions, primaryDim, secondaryDim).selectedMeasure;
        const maxSecondaryMeasure = selectOmbrelloneIdealMeasure(ombrelloniConfiguration[getIndexOmbrellone()].meshDimensions, primaryDim, secondaryDim).maxSecondaryMeasure;
        let misuraPrincipaleSelezionata;
        let misuraSecondariaSelezionata;   
        // Se la selezione della misura è automatica...
        if (selezioneMisuraAutomaticaOmbr) {
            misuraPrincipaleSelezionata = getMisuraPrincipale(idealMeasure);
            misuraSecondariaSelezionata = getMisuraSecondaria(idealMeasure);   
        // Se è manuale...
        } else {
            misuraPrincipaleSelezionata = getMisuraPrincipale(misuraOmbrelloni);  
            misuraSecondariaSelezionata = getMisuraSecondaria(misuraOmbrelloni);   
        }                     
        // Verifica quanti ombrelloni posizionare
        const numOmbrelloni = Math.trunc(primaryDim / misuraPrincipaleSelezionata);
        const fractionalPrimaryPart = (primaryDim % misuraPrincipaleSelezionata).toFixed(2);   
        const fractionalSecondaryPart = (secondaryDim / misuraSecondariaSelezionata);   
        let newScaleX;
        let newScaleZ;
        // Se la selezione della misura è automatica...
        if (selezioneMisuraAutomaticaOmbr) {
            newScaleX = maxSecondaryMeasure >= secondaryDim ? 
                    (ombrelloniConfiguration[getIndexOmbrellone()].meshScale[0] * misuraSecondariaSelezionata) * fractionalSecondaryPart :
                    (ombrelloniConfiguration[getIndexOmbrellone()].meshScale[0] * maxSecondaryMeasure);
            newScaleZ = (ombrelloniConfiguration[getIndexOmbrellone()].meshScale[2] * misuraPrincipaleSelezionata) + ((ombrelloniConfiguration[getIndexOmbrellone()].meshScale[2] * fractionalPrimaryPart) / numOmbrelloni)
        // Se è manuale...
        } else { 
            newScaleX = (ombrelloniConfiguration[getIndexOmbrellone()].meshScale[0] * misuraSecondariaSelezionata);
            newScaleZ = (ombrelloniConfiguration[getIndexOmbrellone()].meshScale[2] * misuraPrincipaleSelezionata);          
        }  
        const distanzaOmbrelloni = primaryDim / numOmbrelloni;  
        scale[0] = newScaleX;
        scale[2] = newScaleZ;       
        if (selezioneMisuraAutomaticaOmbr) {
            // Determina la direzione da seguire  
            for (let i=1; i <= numOmbrelloni; i++) {
                // Verifica la direzione del lato
                if (latoOmbrelloni.toString() === E_MainLato.Lato1.toString()) {                    
                    if (genereOmbrellone.toString() === E_GenereOmbrellone.Centrale.toString()) {
                        posX = 0;
                    }
                    else {                      
                        posX = -secondaryDim/2 - offsetPavimentoEsterno;
                        // Se ci sono ombrelloni contrapposti
                        if (isContrapposto) {                           
                            contrappostoX = secondaryDim/2 + offsetPavimentoEsterno;
                            contrappostoZ = ((-primaryDim/2) - ombrelloniConfiguration[getIndexOmbrellone()].offSetPosizioneOmbrellone[2] + (i * (distanzaOmbrelloni)) - (distanzaOmbrelloni/2)) + offsetPavimentoEsterno; 
                        }   
                    }
                    posZ = ((-primaryDim/2) - ombrelloniConfiguration[getIndexOmbrellone()].offSetPosizioneOmbrellone[2] + (i * (distanzaOmbrelloni)) - (distanzaOmbrelloni/2)) + offsetPavimentoEsterno; 
                    dispatch(setLunghezzaLateraleCristal({lato: E_MainLato.Lato1.toString(), lunghezzaCristalSulLato: primaryDim * 1}));  
                    dispatch(setLunghezzaLateraleCristal({lato: E_MainLato.Lato2.toString(), lunghezzaCristalSulLato: misuraSecondariaSelezionata}));  
                    dispatch(setLunghezzaLateraleCristal({lato: E_MainLato.Lato3.toString(), lunghezzaCristalSulLato: primaryDim * 1}));  
                    dispatch(setLunghezzaLateraleCristal({lato: E_MainLato.Lato4.toString(), lunghezzaCristalSulLato: misuraSecondariaSelezionata}));             
                } else if (latoOmbrelloni.toString() === E_MainLato.Lato2.toString()) {
                    if (genereOmbrellone.toString() === E_GenereOmbrellone.Centrale.toString()) {
                        posZ = 0;
                    } else {
                        posZ = -secondaryDim/2 - offsetPavimentoEsterno;
                        // Se ci sono ombrelloni contrapposti
                        if (isContrapposto) {
                            contrappostoZ = secondaryDim/2 + offsetPavimentoEsterno;
                            contrappostoX = ((-primaryDim/2) - ombrelloniConfiguration[getIndexOmbrellone()].offSetPosizioneOmbrellone[2] + (i * (distanzaOmbrelloni)) - (distanzaOmbrelloni/2)) + offsetPavimentoEsterno;
                        }   
                    }
                    posX = ((-primaryDim/2) - ombrelloniConfiguration[getIndexOmbrellone()].offSetPosizioneOmbrellone[2] + (i * (distanzaOmbrelloni)) - (distanzaOmbrelloni/2)) + offsetPavimentoEsterno;
                    dispatch(setLunghezzaLateraleCristal({lato: E_MainLato.Lato1.toString(), lunghezzaCristalSulLato: misuraSecondariaSelezionata}));  
                    dispatch(setLunghezzaLateraleCristal({lato: E_MainLato.Lato2.toString(), lunghezzaCristalSulLato: primaryDim * 1}));  
                    dispatch(setLunghezzaLateraleCristal({lato: E_MainLato.Lato3.toString(), lunghezzaCristalSulLato: misuraSecondariaSelezionata}));                
                    dispatch(setLunghezzaLateraleCristal({lato: E_MainLato.Lato4.toString(), lunghezzaCristalSulLato: primaryDim * 1}));  
                } else if (latoOmbrelloni.toString() === E_MainLato.Lato3.toString()) {
                    posX = secondaryDim/2 + offsetPavimentoEsterno; 
                    // Se ci sono ombrelloni contrapposti
                    if (isContrapposto) {
                        contrappostoX = -secondaryDim/2 - offsetPavimentoEsterno;
                        contrappostoZ = ((-primaryDim/2) - ombrelloniConfiguration[getIndexOmbrellone()].offSetPosizioneOmbrellone[2] + (i * (distanzaOmbrelloni)) - (distanzaOmbrelloni/2)) + offsetPavimentoEsterno;
                    }   
                    posZ = ((-primaryDim/2) - ombrelloniConfiguration[getIndexOmbrellone()].offSetPosizioneOmbrellone[2] + (i * (distanzaOmbrelloni)) - (distanzaOmbrelloni/2)) + offsetPavimentoEsterno;
                    dispatch(setLunghezzaLateraleCristal({lato: E_MainLato.Lato1.toString(), lunghezzaCristalSulLato: primaryDim * 1}));  
                    dispatch(setLunghezzaLateraleCristal({lato: E_MainLato.Lato2.toString(), lunghezzaCristalSulLato: misuraSecondariaSelezionata}));  
                    dispatch(setLunghezzaLateraleCristal({lato: E_MainLato.Lato3.toString(), lunghezzaCristalSulLato: primaryDim * 1}));  
                    dispatch(setLunghezzaLateraleCristal({lato: E_MainLato.Lato4.toString(), lunghezzaCristalSulLato: misuraSecondariaSelezionata}));             
                } else if (latoOmbrelloni.toString() === E_MainLato.Lato4.toString()) {
                    posX = ((-primaryDim/2) - ombrelloniConfiguration[getIndexOmbrellone()].offSetPosizioneOmbrellone[2] + (i * (distanzaOmbrelloni)) - (distanzaOmbrelloni/2)) + offsetPavimentoEsterno;
                    posZ = secondaryDim/2 + offsetPavimentoEsterno;
                    // Se ci sono ombrelloni contrapposti
                    if (isContrapposto) {
                        contrappostoX = ((-primaryDim/2) - ombrelloniConfiguration[getIndexOmbrellone()].offSetPosizioneOmbrellone[2] + (i * (distanzaOmbrelloni)) - (distanzaOmbrelloni/2)) + offsetPavimentoEsterno;
                        contrappostoZ = -secondaryDim/2 - offsetPavimentoEsterno;
                    }   
                    dispatch(setLunghezzaLateraleCristal({lato: E_MainLato.Lato1.toString(), lunghezzaCristalSulLato: misuraSecondariaSelezionata}));  
                    dispatch(setLunghezzaLateraleCristal({lato: E_MainLato.Lato2.toString(), lunghezzaCristalSulLato: primaryDim * 1}));  
                    dispatch(setLunghezzaLateraleCristal({lato: E_MainLato.Lato3.toString(), lunghezzaCristalSulLato: misuraSecondariaSelezionata}));                
                    dispatch(setLunghezzaLateraleCristal({lato: E_MainLato.Lato4.toString(), lunghezzaCristalSulLato: primaryDim * 1}));  
                }             
                posY = isPedanaVisible ? altezzaPedana + ombrelloniConfiguration[getIndexOmbrellone()].offSetPosizioneOmbrellone[1] : 0;                    
                // Inserisce gli ombrelloni nell'array temporaneo                 
                tempArray.push({
                        mesh: _mesh,
                        rotation: rotation,
                        scale: scale,
                        position: [posX, posY, posZ],                   
                    }
                ); 
                if (isContrapposto) {                
                    tempArray.push({
                            mesh: _mesh,
                            rotation: [rotation[0], yRotationContrapposto, rotation[2]],
                            scale: scale,
                            position: [contrappostoX, posY, contrappostoZ],                   
                        }
                    );                     
                } 
            }  
            // Seleziona l'ombrellone contrapposto centrale
            if (isContrapposto && ombrelloniContrappostiConfiguration.toString() === E_ConfOmbrelloniContrapposti.Compatta.toString()) {
                if (latoOmbrelloni.toString() === E_MainLato.Lato1.toString()) {
                    tempArray.push({
                        mesh: _mesh,
                        rotation: [rotation[0], Math.PI/2, rotation[2]],
                        scale: scale,
                        position: [0, posY, -larghezzaPavimento/2 - offsetPavimentoEsterno],                   
                        }
                    );  
                } else if (latoOmbrelloni.toString() === E_MainLato.Lato2.toString()) {
                    tempArray.push({
                        mesh: _mesh,
                        rotation: [rotation[0], Math.PI, rotation[2]],
                        scale: scale,
                        position: [-lunghezzaPavimento/2 - offsetPavimentoEsterno, posY, 0],                   
                        }
                    );  
                } else if (latoOmbrelloni.toString() === E_MainLato.Lato3.toString()) {
                    tempArray.push({
                        mesh: _mesh,
                        rotation: [rotation[0], -Math.PI/2, rotation[2]],
                        scale: scale,
                        position: [0, posY, larghezzaPavimento/2 + offsetPavimentoEsterno],                   
                        }
                    );  
                } else if (latoOmbrelloni.toString() === E_MainLato.Lato4.toString()) {
                    tempArray.push({
                        mesh: _mesh,
                        rotation: [rotation[0], 0, rotation[2]],
                        scale: scale,
                        position: [lunghezzaPavimento/2 + offsetPavimentoEsterno, posY, 0],                   
                        }
                    );  
                }               
            }              
        } else if (!selezioneMisuraAutomaticaOmbr) {    
            const numOmbr = Math.floor(primaryDim/misuraPrincipaleSelezionata);                  
            const spazioFraOmbrelloni = (primaryDim - (misuraPrincipaleSelezionata * numOmbr))/(numOmbr-1);
            const distanzaOmbrelloni = misuraPrincipaleSelezionata + spazioFraOmbrelloni;    
            posY = isPedanaVisible ? altezzaPedana + ombrelloniConfiguration[getIndexOmbrellone()].offSetPosizioneOmbrellone[1] : 0;                            
            // Verifica la direzione del lato
            if (latoOmbrelloni.toString() === E_MainLato.Lato1.toString()) {
                if (genereOmbrellone.toString() === E_GenereOmbrellone.Centrale.toString()) {
                    posX = 0;
                }
                else {
                    posX = -secondaryDim/2 - offsetPavimentoEsterno;
                    if (isContrapposto) {
                        contrappostoX = secondaryDim/2 + offsetPavimentoEsterno;                      
                    }
                }                 
                // Se ci sono altri ombrelloni, piazzali
                if (numOmbr > 0) {
                    for (let i = 0; i < numOmbr; i++) {                                              
                        const zPos = numOmbr === 1 ? 0 : -primaryDim/2 + (i * distanzaOmbrelloni) + misuraPrincipaleSelezionata/2 - ombrelloniConfiguration[getIndexOmbrellone()].offSetPosizioneOmbrellone[2] + offsetPavimentoEsterno; 
                        tempArray.push({
                            mesh: _mesh,
                            rotation: rotation,
                            scale: scale,
                            position: [posX, posY, zPos],                   
                        });  
                        // Ombrelloni contrapposti  
                        if (isContrapposto) {                                                  
                            tempArray.push({
                                mesh: _mesh,
                                rotation: [rotation[0], 0, rotation[2]],
                                scale: scale,
                                position: [contrappostoX, posY, zPos],                   
                            });          
                        }                                       
                    }
                }  
                const lunghezzaCr = numOmbr === 1 ? misuraPrincipaleSelezionata : primaryDim;                
                dispatch(setLunghezzaLateraleCristal({lato: E_MainLato.Lato1.toString(), lunghezzaCristalSulLato: lunghezzaCr * 1}));  
                dispatch(setLunghezzaLateraleCristal({lato: E_MainLato.Lato2.toString(), lunghezzaCristalSulLato: misuraSecondariaSelezionata}));  
                dispatch(setLunghezzaLateraleCristal({lato: E_MainLato.Lato3.toString(), lunghezzaCristalSulLato: lunghezzaCr * 1}));  
                dispatch(setLunghezzaLateraleCristal({lato: E_MainLato.Lato4.toString(), lunghezzaCristalSulLato: misuraSecondariaSelezionata}));            
            } else if (latoOmbrelloni.toString() === E_MainLato.Lato2.toString()) {
                if (genereOmbrellone.toString() === E_GenereOmbrellone.Centrale.toString()) {
                    posZ = 0;
                } else {
                    posZ = -secondaryDim/2 - offsetPavimentoEsterno;
                    if (isContrapposto) {
                        contrappostoZ = secondaryDim/2 + offsetPavimentoEsterno;                      
                    }
                }
                // Se ci sono altri ombrelloni, piazzali
                if (numOmbr > 0) {
                    for (let i = 0; i < numOmbr; i++) {                                              
                        const xPos = numOmbr === 1 ? 0 : -primaryDim/2 + (i * distanzaOmbrelloni) + misuraPrincipaleSelezionata/2 - ombrelloniConfiguration[getIndexOmbrellone()].offSetPosizioneOmbrellone[2] + offsetPavimentoEsterno; 
                        tempArray.push({
                            mesh: _mesh,
                            rotation: rotation,
                            scale: scale,
                            position: [xPos, posY, posZ],                   
                        });     
                        // Ombrelloni contrapposti  
                        if (isContrapposto) {                                                  
                            tempArray.push({
                                mesh: _mesh,
                                rotation: [rotation[0], Math.PI *3 / 2, rotation[2]],
                                scale: scale,
                                position: [xPos, posY, contrappostoZ],                   
                            });          
                        }                                                         
                    }
                }  
                const lunghezzaCr = numOmbr === 1 ? misuraPrincipaleSelezionata : primaryDim;  
                dispatch(setLunghezzaLateraleCristal({lato: E_MainLato.Lato1.toString(), lunghezzaCristalSulLato: misuraSecondariaSelezionata}));  
                dispatch(setLunghezzaLateraleCristal({lato: E_MainLato.Lato2.toString(), lunghezzaCristalSulLato: lunghezzaCr * 1}));  
                dispatch(setLunghezzaLateraleCristal({lato: E_MainLato.Lato3.toString(), lunghezzaCristalSulLato: misuraSecondariaSelezionata}));                
                dispatch(setLunghezzaLateraleCristal({lato: E_MainLato.Lato4.toString(), lunghezzaCristalSulLato: lunghezzaCr * 1}));  
            } else if (latoOmbrelloni.toString() === E_MainLato.Lato3.toString()) {
                posX = secondaryDim/2 + offsetPavimentoEsterno; 
                if (isContrapposto) {
                    contrappostoX = -secondaryDim/2 - offsetPavimentoEsterno;                      
                }
                /// Se ci sono altri ombrelloni, piazzali
                if (numOmbr > 0) {
                    for (let i = 0; i < numOmbr; i++) {                                              
                        const zPos = numOmbr === 1 ? 0 : -primaryDim/2 + (i * distanzaOmbrelloni) + misuraPrincipaleSelezionata/2 - ombrelloniConfiguration[getIndexOmbrellone()].offSetPosizioneOmbrellone[2] + offsetPavimentoEsterno; 
                        tempArray.push({
                            mesh: _mesh,
                            rotation: rotation,
                            scale: scale,
                            position: [posX, posY, zPos],                   
                        });   
                        // Ombrelloni contrapposti  
                        if (isContrapposto) {                                
                            tempArray.push({
                                mesh: _mesh,
                                rotation: [rotation[0], Math.PI, rotation[2]],
                                scale: scale,
                                position: [contrappostoX, posY, zPos],                   
                            });          
                        }                                                 
                    }
                }  
                const lunghezzaCr = numOmbr === 1 ? misuraPrincipaleSelezionata : primaryDim;  
                dispatch(setLunghezzaLateraleCristal({lato: E_MainLato.Lato1.toString(), lunghezzaCristalSulLato: lunghezzaCr * 1}));  
                dispatch(setLunghezzaLateraleCristal({lato: E_MainLato.Lato2.toString(), lunghezzaCristalSulLato: misuraSecondariaSelezionata}));  
                dispatch(setLunghezzaLateraleCristal({lato: E_MainLato.Lato3.toString(), lunghezzaCristalSulLato: lunghezzaCr * 1}));  
                dispatch(setLunghezzaLateraleCristal({lato: E_MainLato.Lato4.toString(), lunghezzaCristalSulLato: misuraSecondariaSelezionata}));            
            } else if (latoOmbrelloni.toString() === E_MainLato.Lato4.toString()) {
                posZ = secondaryDim/2 + offsetPavimentoEsterno;
                if (isContrapposto) {
                    contrappostoZ = -secondaryDim/2 - offsetPavimentoEsterno;                      
                }
                // Se ci sono altri ombrelloni, piazzali
                if (numOmbr > 0) {
                    for (let i = 0; i < numOmbr; i++) {                                              
                        const xPos = numOmbr === 1 ? 0 : -primaryDim/2 + (i * distanzaOmbrelloni) + misuraPrincipaleSelezionata/2 - ombrelloniConfiguration[getIndexOmbrellone()].offSetPosizioneOmbrellone[2] + offsetPavimentoEsterno; 
                        tempArray.push({
                            mesh: _mesh,
                            rotation: rotation,
                            scale: scale,
                            position: [xPos, posY, posZ],                   
                        });     
                        // Ombrelloni contrapposti  
                        if (isContrapposto) {                                                  
                            tempArray.push({
                                mesh: _mesh,
                                rotation: [rotation[0], Math.PI/2, rotation[2]],
                                scale: scale,
                                position: [xPos, posY, contrappostoZ],                   
                            });          
                        }                                               
                    }
                }  
                const lunghezzaCr = numOmbr === 1 ? misuraPrincipaleSelezionata : primaryDim;  
                dispatch(setLunghezzaLateraleCristal({lato: E_MainLato.Lato1.toString(), lunghezzaCristalSulLato: misuraSecondariaSelezionata}));  
                dispatch(setLunghezzaLateraleCristal({lato: E_MainLato.Lato2.toString(), lunghezzaCristalSulLato: lunghezzaCr * 1}));  
                dispatch(setLunghezzaLateraleCristal({lato: E_MainLato.Lato3.toString(), lunghezzaCristalSulLato: misuraSecondariaSelezionata}));                
                dispatch(setLunghezzaLateraleCristal({lato: E_MainLato.Lato4.toString(), lunghezzaCristalSulLato: lunghezzaCr * 1}));  
            }  
            // Seleziona l'ombrellone contrapposto centrale
            if (isContrapposto && ombrelloniContrappostiConfiguration.toString() === E_ConfOmbrelloniContrapposti.Compatta.toString()) {
                if (latoOmbrelloni.toString() === E_MainLato.Lato1.toString()) {
                    tempArray.push({
                        mesh: _mesh,
                        rotation: [rotation[0], Math.PI/2, rotation[2]],
                        scale: scale,
                        position: [0, posY, -larghezzaPavimento/2 - offsetPavimentoEsterno],                   
                        }
                    );  
                } else if (latoOmbrelloni.toString() === E_MainLato.Lato2.toString()) {
                    tempArray.push({
                        mesh: _mesh,
                        rotation: [rotation[0], Math.PI, rotation[2]],
                        scale: scale,
                        position: [-lunghezzaPavimento/2 - offsetPavimentoEsterno, posY, 0],                   
                        }
                    );  
                } else if (latoOmbrelloni.toString() === E_MainLato.Lato3.toString()) {
                    tempArray.push({
                        mesh: _mesh,
                        rotation: [rotation[0], -Math.PI/2, rotation[2]],
                        scale: scale,
                        position: [0, posY, larghezzaPavimento/2 + offsetPavimentoEsterno],                   
                        }
                    );  
                } else if (latoOmbrelloni.toString() === E_MainLato.Lato4.toString()) {
                    tempArray.push({
                        mesh: _mesh,
                        rotation: [rotation[0], 0, rotation[2]],
                        scale: scale,
                        position: [lunghezzaPavimento/2 + offsetPavimentoEsterno, posY, 0],                   
                        }
                    );  
                }               
            }              
        }                      
        
        // Se la selezione della misura è automatica...
        if (selezioneMisuraAutomaticaOmbr) {
            // Aggiorna la UI della misura ombrelloni
            dispatch(handleOmbrelloniDimensioneAuto(idealMeasure.toString()));
            dispatch(handleOmbrelloniDimensioni(idealMeasure.toString()));
        }         
        setOmbrelloniArray(tempArray);  
        // Salva i dati degli ombrelloni nello state generale 
        const dataArray = tempArray.map(element => {        
            return {     
                mainDimension: misuraPrincipaleSelezionata,
                secondaryDimension: misuraSecondariaSelezionata,    
                position: element.position,
                rotation: element.rotation,
                scale: element.scale,           
                realDimension: distanzaOmbrelloni,   
            }
        });     
        dispatch(handleDataOmbrelloni(dataArray));    
    }

    // Lancia il calcolo e la generazione dei vari tipi di ombrellone
    const generateOmbrelloni = () => { 
        // Resetta gli ombrelloni ad ogni nuova generazione  
        resetOmbrelloni();
        dispatch(handleDataOmbrelloni([]));
        // Se è impostato su scegli, non selezionare la mesh ombrellone
        if (tipoOmbrelloni.toString() === E_TipoOmbrellone.Scegli.toString()) {         
            dispatch(showMessage("Scegli un tipo di ombrellone"));
            return;
        }
        dispatch(deleteMessage());   
        const _mesh = !isMantovanaSelected ? ombrelloniConfiguration[getIndexOmbrellone()].mesh : ombrelloniConfiguration[getIndexOmbrellone()].meshMantovana; 
        const offsetPavimentoEsterno = ombrelloniConfiguration[getIndexOmbrellone()].offSetPosizioneOmbrellone[2];       
        if (genereOmbrelloni.toString() === E_GenereOmbrellone.Braccio.toString() || genereOmbrelloni.toString() === E_GenereOmbrellone.Sbalzo.toString()) {
            switch(latoOmbrelloni.toString()) {                   
                case E_MainLato.Scegli.toString(): 
                    dispatch(showMessage("Scegli un lato per posizionare gli ombrelloni a braccio/sbalzo"));                                                        
                break;      
                case E_MainLato.Lato1.toString(): 
                    if (!isOmbrelloniContrappostiSelected) {
                        generaOmbrelloniMainCode(E_GenereOmbrellone.Braccio, E_MainLato.Lato1, lunghezzaPavimento, larghezzaPavimento, offsetPavimentoEsterno, _mesh, false);
                    }
                    else {
                        generaOmbrelloniMainCode(E_GenereOmbrellone.Braccio, E_MainLato.Lato1, lunghezzaPavimento, larghezzaPavimento, offsetPavimentoEsterno, _mesh, true);
                    }
                    setIndexLatoPrincipale(1);
                break;
                case E_MainLato.Lato2.toString(): 
                    if (!isOmbrelloniContrappostiSelected) {
                        generaOmbrelloniMainCode(E_GenereOmbrellone.Braccio, E_MainLato.Lato2, lunghezzaPavimento, larghezzaPavimento, offsetPavimentoEsterno, _mesh, false);
                    }
                    else {
                        generaOmbrelloniMainCode(E_GenereOmbrellone.Braccio, E_MainLato.Lato2, lunghezzaPavimento, larghezzaPavimento, offsetPavimentoEsterno, _mesh, true); 
                    }
                    setIndexLatoPrincipale(2);
                break;
                case E_MainLato.Lato3.toString(): 
                    if (!isOmbrelloniContrappostiSelected) {
                        generaOmbrelloniMainCode(E_GenereOmbrellone.Braccio, E_MainLato.Lato3, lunghezzaPavimento, larghezzaPavimento, offsetPavimentoEsterno, _mesh, false);
                    }
                    else {
                        generaOmbrelloniMainCode(E_GenereOmbrellone.Braccio, E_MainLato.Lato3, lunghezzaPavimento, larghezzaPavimento, offsetPavimentoEsterno, _mesh, true);
                    }
                    setIndexLatoPrincipale(3);
                break;
                case E_MainLato.Lato4.toString(): 
                    if (!isOmbrelloniContrappostiSelected) {
                        generaOmbrelloniMainCode(E_GenereOmbrellone.Braccio, E_MainLato.Lato4, lunghezzaPavimento, larghezzaPavimento, offsetPavimentoEsterno, _mesh, false);
                    }
                    else {
                        generaOmbrelloniMainCode(E_GenereOmbrellone.Braccio, E_MainLato.Lato4, lunghezzaPavimento, larghezzaPavimento, offsetPavimentoEsterno, _mesh, true);
                    }
                    setIndexLatoPrincipale(4);
                break;
                default:
                    dispatch(showMessage("Scegli un lato per posizionare gli ombrelloni a braccio/sbalzo"));  
                break;
            }                      
        } else if (genereOmbrelloni.toString() === E_GenereOmbrellone.Centrale.toString()) {
            // Verifica il lato più lungo per disporli in quello
            let mainDirection = E_MainLato.Scegli;
            if (larghezzaPavimento * 1 >= lunghezzaPavimento * 1) {
                mainDirection = E_MainLato.Lato1;
                setIndexLatoPrincipale(1);
            } else {
                mainDirection = E_MainLato.Lato2;
                setIndexLatoPrincipale(2);
            }
            dispatch(handleOmbrelloniLato(mainDirection.toString()));
            generaOmbrelloniMainCode(E_GenereOmbrellone.Centrale, mainDirection, lunghezzaPavimento, larghezzaPavimento, offsetPavimentoEsterno, _mesh);
        }           
    }   

    // Elimina gli ombrelloni dagli array
    const resetOmbrelloni = () => {          
        setOmbrelloniArray([]);       
    }  
    
    useEffect(() => {     
        generateOmbrelloni(); 
    }, [ombrelloniMenuVisible, isPedanaVisible, lunghezzaPavimento, larghezzaPavimento, altezzaPedana, genereOmbrelloni, tipoOmbrelloni, misuraOmbrelloni, misuraAutomaticaOmbrelloni, latoOmbrelloni, selezioneMisuraAutomaticaOmbr, tessutoOmbrelloni, isMantovanaSelected, isVelcroSelected, isOmbrelloniContrappostiSelected, ombrelloniContrappostiConfiguration]);
    
    return (
        <group>         
            {ombrelloniArray.map((element, index) => (  
                <ClonedObject mesh={element.mesh} key={`ombrellone_${element}_${index}_${isMantovanaSelected.toString()}`} position={element.position} rotation={element.rotation} scale={element.scale} mustHaveLight={hasLed} />
            ))}    
            {/* Se non c'è la pedana, posiziona le basi degli ombrelloni */}
            {!isPedanaVisible && ombrelloniArray.map((element, index) => (
                <ClonedObject mesh={ombrelloniConfiguration[getIndexOmbrellone()].meshBase} key={`base_${element}_${index}`} position={element.position} rotation={element.rotation}/>
            ))}
            {/*Piazza le gondaie*/}
            {isGrondaieSelected && <Grondaie indexLatoPrincipale={indexLatoPrincipale} misuraPrincipale={misuraPrincipaleOmbrellone} misuraSecondaria={misuraSecondariaOmbrellone}/>}        
        </group>
    );       
}